<template>

  <div class="col-12 table-responsive">

    <table class="table table-bordered">

      <tr>
        
        <th 
          v-for="tableParameterItem in PARAM" 
          v-bind:key="tableParameterItem.key" >
          {{ tableParameterItem.text || tableParameterItem.key }}
        </th>

      </tr>

      <tr 
        v-for="(leaseDataItem, leaseDataIndex) in leaseData"
        v-show="leaseDataItem.leaseSelected"
        v-bind:key="leaseDataItem.id" >

        <td 
          v-for="tableParameterItem in PARAM" 
          v-bind:key="tableParameterItem.key"
          v-show="!tableParameterItem.hide" >

          <span v-if="tableParameterItem.key === 'index'">{{ leaseDataIndex + 1 }}</span>

          <input
            v-else-if="tableParameterItem.key === 'leaseSelected'"
            v-model="leaseDataItem['leaseSelected']"
            type="checkbox"
            v-bind="leaseEnableEdit ? {} : {'disabled':0}"
            v-on:input="onLeaseSelectedChange(leaseDataItem, leaseDataIndex)" />

          <div 
            v-else-if="tableParameterItem.key === 'status'"
            v-html="leaseDataItem['stopBillDate'] ? 'Stop Bill' : leaseDataItem[tableParameterItem.key]" />

          <div 
            v-else
            v-html="leaseDataItem[tableParameterItem.key]" />
          
        </td>

      </tr>

      <tr>
        <td 
          v-for="tableParameterItem in PARAM" 
          v-bind:key="tableParameterItem.key" >
          {{ leaseTotal[tableParameterItem.key] }}
        </td>

      </tr>
        
    </table>

    <button 
      v-show="leaseEnableAddDelete"
      class="btn btn-rounded btn-primary"
      v-on:click.prevent="onLeaseAddClick">
      Add Product Subscription
    </button>

    <TemplateFeedback ref="leaseFeedback" class="mt-1"/>

  </div>

</template>

<script>
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import helper from "@/components/Utility/Helper"

const PARAM = [
  {
    key: 'index',
    text: '#',
  },
  // {
  //   key: 'leaseSelected',
  //   text: ' '
  // },
  {
    key: 'leaseZone',
    text: 'Zone'
  },
  {
    key: 'leaseProductName',
    text: 'Product Name'
  },
  {
    key: 'leaseParkerInformation',
    text: 'Parker Information',
  },
  {
    key: 'status',
    text: 'Subscription Status',
  },
  {
    key: 'leasePasscard',
    text: 'Passcard',
  },
  {
    key: 'leasePasscardStatus',
    text: 'Passcard Status',
  },
  {
    key: 'leaseTerminationDate',
    text: 'Termination Effective Date',
  },
  {
    key: 'leaseReinstatementFees',
    text: 'Reinstatement Fee (RM)',
  },
];

export default {
  name: "PagePLProductChangeFormLease",
  props: ['tableParameter'],
  components: {
    TemplateFeedback,
  },
  data () {
    return {
      PARAM,

      tableSeason: null,
      tableParker: null,

      leaseData: [{}],
      leaseTotal: {},
      leaseEnableAddDelete: false,
      leaseEnableEdit: false,

      PRODUCT_PARAMS: ['leaseProductDeposit', 'leaseProductEstbFee', 'leaseProductInitialParkingFee', 'leaseProductInitialPayment', 'leaseProductParkingFee'],
      PARKER_PARAMS: ['leaseParkerName', 'leaseParkerMobile', 'leaseParkerPlate', 'leaseParkerEmail'],
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
  },
  methods: {
    setLeaseData(leaseData, leaseEnableEdit) {
      this.leaseData = leaseData || [];
      this.leaseEnableEdit = leaseEnableEdit;
    },
    setLeaseTotal(leaseTotal) {
      leaseTotal = leaseTotal || {};
      this.PRODUCT_PARAMS.forEach(k => {
        leaseTotal[k + 'Text'] = leaseTotal[k + 'Text'] || helper.formatMoney(leaseTotal[k]);
      });
      this.leaseTotal = leaseTotal;
    },

    setLeaseDataSeason(data, season) {
      if(!season) {
        data['seasonID'] = null;
        this.removeLeaseDataSeasonField(data);
      }
    },
    setLeaseDataParker(data, parker) {
      if(!parker) {
        data['parkerID'] = null;
        this.removeLeaseDataParkerField(data);
      } else {
        data['leaseParkerInformation'] = helper.plFormParker(parker);
        this.$forceUpdate();
      }
    },
    
    removeLeaseDataSeasonField(data) {
      this.PRODUCT_PARAMS.forEach(k => {
        data[k] = null;
        data[k + 'Text'] = null;
      })
    },
    removeLeaseDataParkerField(data) {
      this.PARKER_PARAMS.forEach(k => {
        data[k] = null;
      })
    },

    onLeaseSelectedChange(leaseDataItem, leaseDataIndex) {
      this.leaseData.forEach(lease => lease['leaseSelected'] = (lease == leaseDataItem ? 1 : 0))
      this.$forceUpdate();
      this.$emit('lease-season-change');
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/ParkingLicense/PagePLReinstatementFormLease.vue